import { render, staticRenderFns } from "./OnboardingQuestions.vue?vue&type=template&id=387e99b2&scoped=true&"
import script from "./OnboardingQuestions.vue?vue&type=script&lang=js&"
export * from "./OnboardingQuestions.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingQuestions.vue?vue&type=style&index=0&id=387e99b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387e99b2",
  null
  
)

export default component.exports